var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BLink',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"workflow-bookmark-link",attrs:{"title":_vm.title},on:{"click":_vm.onClick}},[(_vm.checked)?_c('FontAwesomeIcon',{attrs:{"icon":['fas', 'star']}}):_c('FontAwesomeIcon',{attrs:{"icon":['far', 'star']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }